// One rule for every Restricted-access entry point: manual add and Save draft.

// Same check the classic share flow has always used: "x@y.z" shape, a dot after the "@".
export const isValidShareEmail = (value: string) => {
  const email = value.trim();
  const atIndex = email.indexOf('@');
  const lastDotIndex = email.lastIndexOf('.');
  return (
    atIndex > 0 &&
    lastDotIndex > atIndex + 1 &&
    lastDotIndex < email.length - 1
  );
};

// Dot-separated labels ending in a 2+ letter TLD; no "@", spaces or wildcard.
const DOMAIN_REGEX =
  /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

export const isValidShareDomain = (value: string) =>
  DOMAIN_REGEX.test(value.trim());
